import React from 'react';
import {StaticRouter, Route} from 'react-router';
import DashboardLoader from './Common/Loaders/DashboardLoader';
import {getTheme} from '@ey/styled-theme';
import {ThemeProvider} from 'styled-components';

const LoaderContainer = (props) => {
	const context = {};
	return (
		<ThemeProvider theme={getTheme()}>
		<StaticRouter location={props.path} context={context}>
			<Route path="/dashboard" component={DashboardLoader} exact />
		</StaticRouter>
		</ThemeProvider>
	);
};

export default LoaderContainer;
